const LoanStatusBadge = ({ status }: { status: string }) => {
  const getTransactionColorAndName = (status: string) => {
    switch (status) {
      case "submitted":
      case "paid":
        return {
          color: "#D1FAE5",
          name: "success",
          text: "#065F46",
        };
      case "disbursed":
        return {
          color: "#135EE5",
          name: "success",
          text: "#fff",
        };
      case "declined":
        return {
          color: "#FE4D97",
          name: "failed",
          text: "#fff",
        };
      default:
        return {
          color: "#FEF3C7",
          name: "pending",
          text: "#92400E",
        };
    }
  };

  return (
    <span
      style={{
        backgroundColor: getTransactionColorAndName(status).color,
        color: getTransactionColorAndName(status).text,
      }}
      className="rounded-full py-2 px-3 text-xs text-white"
    >
      {status}
    </span>
  );
};

export default LoanStatusBadge;
